import React from 'react';

import {PlaceholderWrapperComponent} from "../../placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../models/device.view-model";
import {Calendar} from "../../../icons/calendar";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../app/consts/colors";

export class ScoresMobileHeaderDaterPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresMobileHeaderDaterPlaceholder = (props: ScoresMobileHeaderDaterPlaceholderProps) => {
  const dates: Array<Object> = [];
  const numOfDates: Number = 5;

  for (let i = 0; i < numOfDates; i++) {
    dates.push({
      key: i
    });
  }

  return (
    <PlaceholderWrapperComponent className={'scores-mobile-header-dater-placeholder-container'}>
      <div className={'scores-mobile-header-dater-placeholder-content'}>
        <div className={'scores-mobile-header-dater-placeholder-mobile-dater'}>
          {
            dates.map((sectionProps) => {
              return (
                <div {...sectionProps} className={'scores-mobile-header-dater-placeholder-mobile-date-container'}>
                  <div className={'scores-mobile-header-dater-placeholder-mobile-day'}/>
                  <div className={'scores-mobile-header-dater-placeholder-mobile-date'}/>
                </div>
              )
            })
          }
          <div className={'scores-mobile-header-dater-placeholder-mobile-date-container'}>
            <Calendar fill={useThemeColor(COLORS.grayPrimary)}/>
          </div>
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
}
